import * as ActionTypes from '../constants/ActionTypes';
import update from 'immutability-helper';

const initialState = () => ({
    object: {
        typeTerms: [],
        countBeds: [],
        amenities: [],
        rangeTypes: [],
        lifestyles: [],
        poolValues: [],
        viewsValues: [],
        floorValues: [],
        countGuests: [],
        garageValues: [],
        gardenValues: [],
        countBedrooms: [],
        newTypeValues: [],
        kitchenValues: [],
        typeConditions: [],
        countBathrooms: [],
        conditionValues: [],
        furnitureValues: [],
        typeOrientations: [],
        orientationValues: [],
        typeApartmentsRent: [],
        typeApartmentsSell: [],
        ourExclusiveValues: [],
        typeRuleReservations: []
    },
    help: {
        client: [],
        owner: []
    },
    main: {},
    isGoogleApiInit: false,
    currencies: []
});

export default (state = initialState(), action) => {
    let services = state.services;
    let agreement = state.agreement;

    let index;

    switch (action.type) {
        case ActionTypes.SET_GOOGLE_API_INIT:
            return {...state, isGoogleApiInit: action.payload};
        case ActionTypes.SET_CONFIGURATION:
            return {
                ...state,
                help: action.payload.help,
                main: action.payload.main,
                object: action.payload.object,
                services: action.payload.services,
                exports: action.payload.exports,
                agreement: action.payload.agreement,
                privacyPolicy: action.payload.privacyPolicy,
                currencies: action.payload.currencies,
                stripePublicKey: action.payload.stripePublicKey
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Configuration.js